<template>
  <!--
      	作者：luoyiming
      	时间：2020-06-25
      	描述：插件中心-团队业绩-计算单列表
      -->
  <div class="user">
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="createClick">创建结算单</el-button>
    </div>
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">

        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.keyword" placeholder="请输入结算单单号查询"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="statement_no" label="结算单号"></el-table-column>
            <el-table-column prop="total_rebate" label="返利总额"></el-table-column>
            <el-table-column prop="total_user" label="代理人数" ></el-table-column>
            <el-table-column prop="year" label="年度" ></el-table-column>
            <el-table-column prop="month" label="月度" ></el-table-column>
            <el-table-column prop="statustext" label="状态">
              <template slot-scope="scope">
                <span class="gray" v-if="scope.row.status == 0">待确认</span>
                <span class="red" v-if="scope.row.status == 1">待发放</span>
                <span class="green" v-if="scope.row.status == 2">已发放</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="detailClick(scope.row)" type="text" size="small">查看详情</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import GroupAwardApi from '@/api/groupaward.js';
  export default {
    components: {},
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        form: {},
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        formInline: {},
        status: ['未开始', '进行中', '已结束'],
        file:{},
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        GroupAwardApi.statementList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {
              self.loading = false;
          });
      },

      /*打开添加*/
      createClick() {
        this.$router.push('/plus/groupaward/statement/create');
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*场次管理*/
      detailClick(row) {
        let id = row.id;
        this.$router.push({
          path: '/plus/groupaward/statement/detail',
          query: {
            id: id
          }
        })
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/groupaward/statement/index.vue